module.exports = __webpack_public_path__ + "img/mezzo0.27bc00cc.png";